import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_ND_DEMO_TCA_3 = {
  title:
    "Empowering your network\n with vendor-agnostic function \n and service templates portal",
  subtitle: "Network designer",
  text: `Unleash seamless control over your network assets. Effortlessly\n onboard, preview, download, and delete network function and\n network service packages — <b>all fortified with TOSCA\n validation.</b>\n\n Embrace compatibility with ETSI and AWS TNB standards for a\n future-proof solution.`,
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_309"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage("ILO_307");
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ILO/TCA/TCA_ND_Demo_3_Screen_1.png",
          imageStyle: { position: "absolute", right: "0", top: "0" },
        },
        {
          image: "ILO/TCA/TCA_ND_Demo_3_Screen_2.png",
          imageStyle: { position: "absolute", right: "0", top: "0" },
        },
        {
          image: "ILO/TCA/TCA_ND_Demo_3_Screen_3.png",
          imageStyle: { position: "absolute", right: "0", bottom: "50px" },
        },
      ]}
      conversationStyle={{ width: "auto" }}
      pageNumber={"ILO_308"}
    />
  ),
};
